/** Debounce call to exalead for search query (community, conversation) */
export const EXALEAD_SEARCH_DEBOUNCE = 1000
/** Maximum time the debounce waits to make an API call */
export const EXALEAD_SEARCH_MAX_WAIT = 3000
